import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { useSelector } from 'react-redux';

import { AdfoxBanner } from 'shared/components/AdfoxBanner';
import { selectIsAgent } from 'shared/selectors';

import { useAdfoxPuids } from '../hooks/useAdfoxPuids';

const ADFOX_PARAMETERS = {
  p1: 'bvknz',
  p2: 'y',
};

export const StretchBannerContainer: React.FC = () => {
  const stretchBannerRoot = React.useRef<Root | null>(null);
  const elementRef = React.useRef<HTMLElement | null>(null);

  const isAgent = useSelector(selectIsAgent);
  const adfoxPuids = useAdfoxPuids();
  const adfoxParameters = React.useMemo(
    () => ({
      ...adfoxPuids,
      ...ADFOX_PARAMETERS,
    }),
    [adfoxPuids],
  );

  const resetStretchBannerContainerMinHeight = React.useCallback(() => {
    if (elementRef.current) {
      elementRef.current.style.minHeight = '0';
    }
  }, []);

  React.useEffect(() => {
    if (!stretchBannerRoot.current) {
      const el = document.getElementById('adfox-stretch-banner');

      if (el) {
        elementRef.current = el;
        stretchBannerRoot.current = createRoot(el);

        stretchBannerRoot.current.render(
          <AdfoxBanner
            onMount={resetStretchBannerContainerMinHeight}
            disableYan={isAgent}
            params={adfoxParameters}
            analyticsEventName="StretchBanner"
            minHeight="200px"
            width="100%"
          />,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
